module.exports = __webpack_public_path__ + "static/img/kn-Xorio.fbbf58b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kn-Xorio.jpg
// module id = oJVE
// module chunks = 1